<app-bread-crumbs [breadcrumbs]="breadcrumbItems"></app-bread-crumbs>

<div class="form-creation-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-11 col-11">
        <div
          class="form-wrapper register-form-container"
          [class.d-none]="activeTap != 'register'"
          >
          <div class="form-wrapper__header">
            <h2 data-translation-key="buyer_register_register_new">
              {{ "buyer_register.register_new" | translate }}
            </h2>
            <!-- <app-language-switcher [theme]="'dark'"></app-language-switcher> -->
          </div>
          <div class="notice-box">
            <p data-translation-key="buyer_register_register_note">
              {{ "buyer_register.register_note" | translate }}
            </p>
          </div>
          <form [formGroup]="formData" (ngSubmit)="next()">
            <div class="form-grid">
              <ng-container formGroupName="user">
                <!-- fullname -->
                <!-- email -->
                <div class="form-group input-container">
                  <label
                    class="label"
                    for="name"
                    class="label"
                    data-translation-key="buyer_register_full_name"
                    >
                    {{ "buyer_register.full_name" | translate }}
                    <span class="required"> * </span>
                  </label>

                  <input
                    [ngClass]="{
                      'is-invalid':
                        (formData.get('user.name')?.errors &&
                          formData.get('user.name')?.touched) ||
                        (showErrors &&
                          formData.get('user.name')?.errors?.serverError)
                    }"
                    matInput
                    [placeholder]="'buyer_register.enter_full_name' | translate"
                    formControlName="name"
                    class="input-field"
                    data-translation-key="buyer_register_enter_full_name"
                    />

                    @if (
                      formData.get('user.name')?.touched &&
                      formData.get('user.name')?.invalid
                      ) {
                      <mat-error
                        >
                        @if (formData.get('user.name')?.hasError('required')) {
                          <span
                            data-translation-key="buyer_register_full_name_required"
                            >
                            {{ "buyer_register.full_name_required" | translate }}
                          </span>
                        }
                        @if (
                          formData.get('user.name')?.hasError('invalidFullName')
                          ) {
                          <span
                            data-translation-key="buyer_register_full_name_validation"
                            >
                            {{ "buyer_register.full_name_validation" | translate }}
                          </span>
                        }
                        @if (formData.get('user.name')?.errors?.serverError) {
                          <span
                            >
                            {{ formData.get("user.name")?.errors?.serverError }}
                          </span>
                        }
                      </mat-error>
                    }
                  </div>
                  <div class="form-group input-container">
                    <label
                      class="label"
                      for="email"
                      data-translation-key="buyer_register_email"
                      >{{ "buyer_register.email" | translate }}
                      <span class="required"> * </span>
                    </label>

                    <input
                    [ngClass]="{
                      'is-invalid':
                        (formData.get('user.email')?.errors &&
                          formData.get('user.email')?.touched) ||
                        (showErrors &&
                          formData.get('user.email')?.errors?.serverError)
                    }"
                      id="email"
                      type="email"
                      matInput
                    [placeholder]="
                      'buyer_register.enter_your_email' | translate
                    "
                      formControlName="email"
                      class="input-field"
                      data-translation-key="buyer_register_enter_your_email"
                      />
                      <div
                        class="help-text"
                        data-translation-key="buyer_register_email_note"
                        >
                        {{ "buyer_register.email_note" | translate }}
                      </div>
                      @if (
                        formData.get('user.email')?.touched &&
                        formData.get('user.email')?.invalid
                        ) {
                        <mat-error
                          >
                          @if (formData.get('user.email')?.hasError('required')) {
                            <span
                              data-translation-key="buyer_register_email_required"
                              >
                              {{ "buyer_register.email_required" | translate }}
                            </span>
                          }
                          @if (
                            formData.get('user.email')?.hasError('invalidEmail')
                            ) {
                            <span
                              data-translation-key="buyer_register_email_invalid"
                              >
                              {{ "buyer_register.email_invalid" | translate }}
                            </span>
                          }
                          @if (formData.get('user.email')?.errors?.serverError) {
                            <span
                              >
                              {{ formData.get("user.email")?.errors?.serverError }}
                            </span>
                          }
                        </mat-error>
                      }
                    </div>

                    <!-- phone and country code -->
                  </ng-container>

                  <ng-container formGroupName="buyer">
                    <!-- country  -->
                    <!-- city  -->

                    <div class="form-group input-container">
                      <label
                        for="country"
                        class="label"
                        data-translation-key="buyer_register_country"
                        >
                        {{ "buyer_register.country" | translate }}
                        <span class="required"> * </span>
                      </label>
                      <ng-select
                    [ngClass]="{
                      'is-invalid':
                        (formData.get('buyer.country_id')?.errors &&
                          formData.get('buyer.country_id')?.touched) ||
                        (showErrors &&
                          formData.get('buyer.country_id')?.errors?.serverError)
                    }"
                        style="width: 100%"
                        [clearable]="false"
                        [placeholder]="'buyer_register.select_country' | translate"
                    [notFoundText]="
                      'buyer_register.no_data_available' | translate
                    "
                        appendTo="body"
                        class="selector input-field-select-wrapper"
                        id="country"
                        formControlName="country_id"
                        [items]="countries"
                        bindLabel="name"
                        bindValue="id"
                        (change)="onCountryChange($event)"
                        [loading]="loading"
                        [searchable]="true"
                        [searchFn]="searchFn"
                        data-translation-key="buyer_register_select_country"
                        >
                        <ng-template ng-label-tmp let-item="item">
                          <div class="country-option">
                            <span>{{ item | translatedName }}</span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <div class="country-option">
                            <span>{{ item | translatedName }}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                      @if (
                        formData.get('buyer.country_id')?.touched &&
                        formData.get('buyer.country_id')?.invalid
                        ) {
                        <mat-error
                          >
                          @if (
                            formData.get('buyer.country_id')?.touched &&
                            formData.get('buyer.country_id')?.hasError('required')
                            ) {
                            <span
                              class="error m-0"
                              data-translation-key="buyer_register_country_required"
                              >
                              {{ "buyer_register.country_required" | translate }}
                            </span>
                          }
                          @if (
                            formData.get('buyer.country_id')?.errors?.serverError
                            ) {
                            <span
                              class="error m-0"
                              >
                              {{
                              formData.get("buyer.country_id")?.errors?.serverError
                              }}
                            </span>
                          }
                        </mat-error>
                      }
                    </div>
                    <div class="form-group input-container">
                      <label
                        class="label"
                        for="city"
                        data-translation-key="buyer_register_city"
                        >
                        {{ "buyer_register.city" | translate }}
                        <span class="required"> * </span>
                      </label>
                      <ng-select
                    [ngClass]="{
                      'is-invalid':
                        (formData.get('buyer.state_city_id')?.errors &&
                          formData.get('buyer.state_city_id')?.touched) ||
                        (showErrors &&
                          formData.get('buyer.state_city_id')?.errors
                            ?.serverError),
                      'is-disabled':
                        states.length === 0 ||
                        formData.get('buyer.state_city_id')?.disabled
                    }"
                        formControlName="state_city_id"
                        [items]="states"
                        bindLabel="name"
                        [bindValue]="'id'"
                    [placeholder]="
                      states.length === 0
                        ? ('buyer_register.select_country_first' | translate)
                        : ('buyer_register.enter_city' | translate)
                    "
                    [disabled]="
                      states.length === 0 ||
                      formData.get('buyer.state_city_id')?.disabled
                    "
                        [searchable]="true"
                        [searchFn]="searchFn"
                        [clearable]="false"
                        [loading]="citiesLoading"
                        appendTo="body"
                    [notFoundText]="
                      'buyer_register.no_data_available' | translate
                    "
                        class="input-field-select-wrapper"
                    [attr.data-translation-key]="
                      states.length === 0
                        ? 'buyer_register_select_country_first'
                        : 'buyer_register_enter_city'
                    "
                        >
                        <ng-template ng-label-tmp let-item="item">
                          <span>{{ item | translatedName }}</span>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <span>{{ item | translatedName }}</span>
                        </ng-template>
                      </ng-select>
                      @if (
                        formData.get('buyer.state_city_id')?.touched &&
                        formData.get('buyer.state_city_id')?.invalid
                        ) {
                        <mat-error
                          >
                          @if (
                            formData
                            .get('buyer.state_city_id')
                            ?.hasError('required')
                            ) {
                            <span
                              data-translation-key="buyer_register_city_required"
                              >
                              {{ "buyer_register.city_required" | translate }}
                            </span>
                          }
                          @if (
                            formData.get('buyer.state_city_id')?.errors?.serverError
                            ) {
                            <span
                              >
                              {{
                              formData.get("buyer.state_city_id")?.errors?.serverError
                              }}
                            </span>
                          }
                        </mat-error>
                      }
                    </div>
                    <!-- address1  -->
                    <!-- address 2  -->
                    <div class="form-group input-container">
                      <label
                        class="label"
                        for="address_1"
                        data-translation-key="buyer_register_address"
                        >
                        {{ "buyer_register.address" | translate }}
                        <span class="required"> * </span>
                      </label>

                      <input
                    [ngClass]="{
                      'is-invalid':
                        (formData.get('buyer.address_1')?.errors &&
                          formData.get('buyer.address_1')?.touched) ||
                        (showErrors &&
                          formData.get('buyer.address_1')?.errors?.serverError)
                    }"
                        id="address_1"
                        matInput
                        [placeholder]="'buyer_register.enter_address' | translate"
                        formControlName="address_1"
                        class="input-field"
                        data-translation-key="buyer_register_enter_address"
                        />
                        @if (
                          formData.get('buyer.address_1')?.touched &&
                          formData.get('buyer.address_1')?.invalid
                          ) {
                          <mat-error
                            >
                            @if (
                              formData.get('buyer.address_1')?.hasError('required')
                              ) {
                              <span
                                data-translation-key="buyer_register_address_required"
                                >
                                {{ "buyer_register.address_required" | translate }}
                              </span>
                            }
                            @if (
                              formData.get('buyer.address_1')?.errors?.serverError
                              ) {
                              <span
                                >
                                {{ formData.get("buyer.address_1")?.errors?.serverError }}
                              </span>
                            }
                          </mat-error>
                        }
                      </div>
                      <div class="form-group input-container">
                        <label
                          class="label"
                          for="address_2"
                          data-translation-key="buyer_register_address2"
                          >
                          {{ "buyer_register.address2" | translate }}

                          <!-- <span class="required"> * </span> -->
                        </label>

                        <input
                    [ngClass]="{
                      'is-invalid':
                        (formData.get('buyer.address_2')?.errors &&
                          formData.get('buyer.address_2')?.touched) ||
                        (showErrors &&
                          formData.get('buyer.address_2')?.errors?.serverError)
                    }"
                          id="address_2"
                          matInput
                          [placeholder]="'buyer_register.enter_address' | translate"
                          formControlName="address_2"
                          class="input-field"
                          data-translation-key="buyer_register_enter_address"
                          />

                          @if (
                            formData.get('buyer.address_2')?.touched &&
                            formData.get('buyer.address_2')?.invalid
                            ) {
                            <mat-error
                              >
                              @if (
                                formData.get('buyer.address_2')?.errors?.serverError
                                ) {
                                <span
                                  >
                                  {{ formData.get("buyer.address_2")?.errors?.serverError }}
                                </span>
                              }
                            </mat-error>
                          }
                        </div>

                        <!-- postalcode  -->

                        <div class="form-group input-container">
                          <label
                            class="label"
                            for="postcode"
                            data-translation-key="buyer_register_post_code"
                            >
                            {{ "buyer_register.post_code" | translate }}
                            <span class="required"> * </span>
                          </label>

                          <input
                            id="postcode"
                    [ngClass]="{
                      'is-invalid':
                        (formData.get('buyer.postcode')?.errors &&
                          formData.get('buyer.postcode')?.touched) ||
                        (showErrors &&
                          formData.get('buyer.postcode')?.errors?.serverError)
                    }"
                            matInput
                            [placeholder]="'buyer_register.enter_post_code' | translate"
                            formControlName="postcode"
                            class="input-field"
                            data-translation-key="buyer_register_enter_post_code"
                            />
                            @if (
                              formData.get('buyer.postcode')?.touched &&
                              formData.get('buyer.postcode')?.invalid
                              ) {
                              <mat-error
                                >
                                @if (
                                  formData.get('buyer.postcode')?.hasError('required')
                                  ) {
                                  <span
                                    data-translation-key="buyer_register_post_code_required"
                                    >
                                    {{ "buyer_register.post_code_required" | translate }}
                                  </span>
                                }
                                @if (
                                  formData.get('buyer.postcode')?.errors?.serverError
                                  ) {
                                  <span
                                    >
                                    {{ formData.get("buyer.postcode")?.errors?.serverError }}
                                  </span>
                                }
                              </mat-error>
                            }
                          </div>
                        </ng-container>
                        <!--Intl Phone-->

                        <ng-container formGroupName="user">
                          <div class="form-group input-container">
                            <label
                              for="mobile-phone"
                              data-translation-key="buyer_register_mobile_phone"
                              >
                              {{ "buyer_register.mobile_phone" | translate }}
                              <span class="required">*</span>
                            </label>

                            <input
                    [ngClass]="{
                      'is-invalid':
                        (formData.get('user.mobile')?.errors &&
                          formData.get('user.mobile')?.touched) ||
                        (showErrors &&
                          formData.get('user.mobile')?.errors?.serverError)
                    }"
                              type="tel"
                              id="mobile-phone"
                              class="form-control input-field"
                              appIntlTelInput
                              [defaultCountry]="selectedCountryIso"
                              [preferredCountries]="['us', 'gb', 'ca', 'au']"
                              [separateDialCode]="true"
                              (countryChange)="onPhoneCountryChange($event)"
                              (validityChange)="onPhoneValidityChange($event)"
                              (phoneNumberChange)="onPhoneNumberChange($event)"
                              (phoneValidationError)="onPhoneValidationError($event)"
                              formControlName="mobile"
                              dir="ltr"
                              appNumbersOnly
                              />

                              <div
                                class="help-text"
                                data-translation-key="buyer_register_mobile_note"
                                >
                                {{ "buyer_register.mobile_note" | translate }}
                              </div>
                              @if (
                                formData.get('user')?.get('mobile')?.touched &&
                                formData.get('user')?.get('mobile')?.invalid
                                ) {
                                <mat-error
                                  >
                                  @if (
                                    formData
                                    .get('user')
                                    ?.get('mobile')
                                    ?.hasError('required')
                                    ) {
                                    <span
                                      data-translation-key="buyer_register_mobile_required"
                                      >
                                      {{ "buyer_register.mobile_required" | translate }}
                                    </span>
                                  }
                                  @if (
                                    formData
                                    .get('user')
                                    ?.get('mobile')
                                    ?.hasError('invalidFormat') || phoneErrorMessage
                                    ) {
                                    <span
                                      >
                                      {{ phoneErrorMessage || "Invalid phone number format" }}
                                    </span>
                                  }
                                  @if (
                                    formData.get('user')?.get('mobile')?.errors?.serverError
                                    ) {
                                    <span
                                      >
                                      {{
                                      formData.get("user")?.get("mobile")?.errors?.serverError
                                      }}
                                    </span>
                                  }
                                </mat-error>
                              }
                            </div>
                          </ng-container>
                        </div>
                        <div class="form-buttons">
                          <button
                            type="submit"
                            class="btn btn-secondary"
                            (click)="back()"
                            data-translation-key="buyer_register_back_homepage"
                            >
                            <!-- [disabled]="!formData.valid" -->
                            @if (appDir == 'ltr') {
                              <i class="bi bi-arrow-left"></i>
                            }
                            @if (appDir == 'rtl') {
                              <i class="bi bi-arrow-right"></i>
                            }
                            {{ "buyer_register.back_homepage" | translate }}
                          </button>
                          <button
                            type="submit"
                            class="btn btn-primary"
                            data-translation-key="buyer_register_next"
                            >
                            <!-- [disabled]="!formData.valid" -->
                            {{ "buyer_register.next" | translate }}
                            @if (appDir == 'rtl') {
                              <i class="bi bi-arrow-left"></i>
                            }
                            @if (appDir == 'ltr') {
                              <i class="bi bi-arrow-right"></i>
                            }
                          </button>
                        </div>
                      </form>
                      <div class="form-wrapper__footer">
                        <p>
                          <span data-translation-key="buyer_register_have_account">{{
                            "buyer_register.have_account" | translate
                          }}</span>
                          <a
                            routerLink="/buyer/auth/login"
                            data-translation-key="buyer_register_sign_in"
                            >
                            {{ "buyer_register.sign_in" | translate }}</a
                            >
                          </p>
                        </div>
                      </div>

                      <div
                        class="form-wrapper"
                        [class.d-none]="activeTap != 'create-password'"
                        >
                        <h2
                          class="form-wrapper__header"
                          data-translation-key="buyer_register_create_new_password"
                          >
                          {{ "buyer_register.create_new_password" | translate }}
                        </h2>
                        <p
                          class="form-description"
                          data-translation-key="buyer_register_create_new_password_note"
                          >
                          {{ "buyer_register.create_new_password_note" | translate }}
                        </p>
                        <app-password-form
                          [urlFront]="urlFront"
                          [showTermsCheckbox]="true"
                          (formChange)="onPasswordFormChange($event)"
                          (formSubmit)="onSubmit()"
                        ></app-password-form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
